import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";

const mineralApi = createApi({
    reducerPath: "core/mineral",
    baseQuery: axiosBaseQuery,
    tagTypes: ["mineralList"],
    endpoints: (builder) => ({
        mineralFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['mineralList'],
            query: (query = '') => ({
                url: "/core/mineral" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        mineralCreate: builder.mutation({
            invalidatesTags: ['mineralList'],
            query: (data) => ({
                url: `/core/mineral`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        mineralUpdate: builder.mutation({
            invalidatesTags: ['mineralList'],
            query: (data) => ({
                url: `/core/mineral/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        mineralDelete: builder.mutation({
            invalidatesTags: ['mineralList'],
            query: (id) => ({ url: "/core/mineral/" + id, method: "DELETE" })
        }),
    })
})

export const { useMineralFindAllQuery, useMineralCreateMutation, useMineralUpdateMutation, useMineralDeleteMutation } = mineralApi;
export { mineralApi };
